<template>
  <v-container class="login-container" fill-height fluid>
    <div class="login-background">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1903 556"
      >
        <path
          class="svg-banner-shape"
          d="M753.1,434.2c110.6,63.7,277.7,70.6,373.4,15.4L1905,0v555.9H0V0.2L753.1,434.2z"
        ></path>
      </svg>
    </div>
    <v-row align="center" justify="center" style="z-index: 10">
      <v-col cols="11" sm="7" md="5" lg="4" xl="3">
        <div class="logo text-center mb-12 font-weight-medium">
          <img :src="'/admin/assets/img/logos/homelogo.png'" />
        </div>
        <v-card>
          <v-card-title class="display-1 justify-center font-weight-medium"
            >Vinculación de pagos</v-card-title
          >
          <v-card-text>
            <p class="mb-0 grey--text">
              Vinculación exitosa, puede cerrar esta ventana
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class MarketplaceLink extends Vue {
    async created() {
      const code = this.$route.query.code;
      if (window.opener) window.opener.postMessage(`mpCode|${code}`, '*');
    }
  }
</script>
